import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "./TableOne.scss";

const TableOne = ({ formDetails, firstColumn, scoringLoading, error }) => {
  const renderSkeletonRows = () => {
    const skeletonRows = [];
    for (let i = 0; i < 3; i++) {
      skeletonRows.push(
        <tr key={`skeleton-${i}`}>
          <td>
            <Skeleton width={300} height={25} />
          </td>
          <td>
            <Skeleton width={150} height={25} />
          </td>
          <td>
            <Skeleton width={150} height={25} />
          </td>
        </tr>
      );
    }
    return skeletonRows;
  };
  return (
    <SkeletonTheme baseColor="#d4d4d4" highlightColor="#f5f5f5">
      <div id="scoring-table-one" className={`scoring-table-one-container `}>
        <table className={`scoring-table-one-details`}>
          <thead>
            <tr>
              <th
                style={{
                  width: "50%",
                  borderRadius: "10px 0px 0px 0px",
                }}
              >
                {firstColumn}
              </th>
              <th
                style={{
                  width: "25%",
                }}
              >
                Number of Nonconformities
              </th>

              <th
                style={{
                  width: "25%",
                  borderRadius: "0px 10px 0px 0px",
                }}
              >
                Nonconformance Points
              </th>
            </tr>
          </thead>
          <tbody>
            {scoringLoading && <>{renderSkeletonRows()}</>}
            {!scoringLoading &&
              !error &&
              formDetails &&
              formDetails.map((row, index) => (
                <tr key={row.id}>
                  <td>{row.results}</td>
                  <td>{row.numOfNonComf}</td>
                  <td>{row.nonComfPoints}</td>
                </tr>
              ))}

            {error && (
              <tr>
                <td colSpan="9" style={{ textAlign: "center" }}>
                  {error}{" "}
                  <span
                    className="refresh-btn"
                    onClick={() => window.location.reload()}
                  >
                    Please try again
                  </span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </SkeletonTheme>
  );
};

export default TableOne;
